"use client";

import { Card, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Droplets, Zap, Shield, House, Waves, Footprints } from "lucide-react";
const services = [{
  title: "Fotovoltaika",
  description: "Kompletní realizace fotovoltaických systémů na klíč s dlouhodobou zárukou",
  icon: Zap,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1543299/img/photovoltaic_installation.png",
  titleClassName: "absolute inset-0 bg-secondary-dark/60 group-hover:bg-secondary-dark/40 transition-all duration-[var(--duration-medium)] !bg-[url(https://vicistimtito.cz/wp-content/uploads/2026/02/fotovoltaika_rodinny_dum_instalace.webp)] absolute inset-0 bg-secondary-dark/60 group-hover:bg-secondary-dark/40 transition-all duration-[var(--duration-medium)] !bg-[url(https://vicistimtito.cz/wp-content/uploads/2026/02/WhatsApp-Image-2026-01-24-at-18.15.59.jpeg)] bg-center bg-cover"
}, {
  title: "Vysokotlaké čištění střech",
  description: "Odstranění mechu, lišejníků a nečistot s profesionální precizností",
  icon: Droplets,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1543299/img/image_06654po7.png",
  titleClassName: "absolute inset-0 bg-secondary-dark/60 group-hover:bg-secondary-dark/40 transition-all duration-[var(--duration-medium)] !bg-[url(https://vicistimtito.cz/wp-content/uploads/2026/02/roof_cleaning_project_2.webp)] bg-center bg-cover absolute inset-0 bg-secondary-dark/60 group-hover:bg-secondary-dark/40 transition-all duration-[var(--duration-medium)] !bg-[url(https://vicistimtito.cz/wp-content/uploads/2026/02/Dachsaeuberung-1.png)] absolute inset-0 bg-secondary-dark/60 group-hover:bg-secondary-dark/40 transition-all duration-[var(--duration-medium)] !bg-[url(https://vicistimtito.cz/wp-content/uploads/2026/02/Dachsaeuberung-1.png)]"
}, {
  title: "Technologická impregnace",
  description: "Hydrofobní ochrana střech a fasád pro maximální životnost",
  icon: Shield,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1543299/img/roof_impregnation_coating.png"
}, {
  title: "Čištění fasád",
  description: "Profesionální péče o exteriér vašeho domu s dlouhodobým efektem",
  icon: House,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1543299/img/facade_cleaning_service.png"
}, {
  title: "Čištění okapů",
  description: "Kompletní údržba a čištění okapového systému",
  icon: Waves,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1543299/img/gutter_cleaning_maintenance.png"
}, {
  title: "Čištění chodníků",
  description: "Vysokotlaké čištění dlažeb a venkovních povrchů",
  icon: Footprints,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1543299/img/walkway_pressure_washing.png"
}];
export default function PrehledSluzeb() {
  return <section id="přehled-služeb" className="dark bg-background text-foreground py-16 md:py-24 px-4 md:px-8">
      <div className="container mx-auto max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {services.map((service, i) => {
          const Icon = service.icon;
          return <Card key={i} data-index={i} className="group relative overflow-hidden bg-secondary border-transparent hover:border-muted/30 transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-2 hover:shadow-strong">
                <div className="relative h-64 overflow-hidden">
                  <div className="absolute inset-0 bg-cover bg-center transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] group-hover:scale-105 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1543299/img/placeholder.png)]" style={{
                backgroundImage: `url(${service.image})`
              }} />
                  <div className={`${service.titleClassName || ""} absolute inset-0 bg-secondary-dark/60 group-hover:bg-secondary-dark/40 transition-all duration-[var(--duration-medium)]`} />
                  
                  <div className={`absolute top-4 right-4 p-3 rounded-lg bg-secondary-dark/80 border border-white/5 ${i === 0 ? "" : "backdrop-blur-sm"}`}>
                    <Icon className="w-6 h-6 text-primary" strokeWidth={1.5} />
                  </div>
                </div>

                <CardHeader className="relative z-10 transition-all duration-[var(--duration-medium)] group-hover:-translate-y-2">
                  <CardTitle className="text-xl font-display text-foreground">
                    {service.title}
                  </CardTitle>
                  <CardDescription className="text-muted-foreground transition-all duration-[var(--duration-medium)] mt-2">
                    {service.description}
                  </CardDescription>
                </CardHeader>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}